var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('a-card',[_c('a-result',{attrs:{"status":"404","title":"404","sub-title":"暂无数据"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"}},[_vm._v(" 返 回 Back ")])]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }